export default __webpack_public_path__ + "static/media/anvandaravtal.0f406e46.pdf";